export const saveBotsActionType = "SAVE_BOTS";
export const getBotsActionType = "GET_BOTS"
export const saveCurrentBotActionType = "SAVE_CURRENT_BOT"
export const editCurrentBotActionType = "EDIT_CURRENT_BOT"
export const getBotsFailed = "GET_BOTS_FAILED"